import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../environments/environment';
// import { AuthService } from './auth.service'; // Import the AuthService
import { Location } from '@angular/common'
import { Observable } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthManagerService {

  authcode: any;
  bearerToken: any;
  private clientId = environment.clientId;

  private apiUrl = '/Mobileapi/send_whatsapp_otp';
  private valUrl = '/Mobileapi/validate_otp';
  private apitoken = '609615431cd8d539b733876c7e0c511dSAGLcHZ6nxEBnE4XlJ1nmcPTZaOXOGIXW';
  private fetchTokenUrl = '/Mobileapi/fetch_bearer_token';
  private updateauthandtokenUrl = '/Mobileapi/giftvoucher_authorization_and_token';

  private authApi = '/Mobileapi/giftvoucher_authorization_verify';
  private bearerTokenApi = '/Mobileapi/giftvoucher_get_bearer_token';

  constructor(private http: HttpClient, private router: Router) { }


  // checkToken(mobile_no: string, p0: () => void): void {
  checkToken(mobile_no: string): void {
    const storedMobileNo = localStorage.getItem('microsite');
    const profileData = localStorage.getItem('profileData');
    if (storedMobileNo === mobile_no && profileData) {
      this.router.navigate(['/index']);
    } else {
      this.sendOtp(mobile_no, this.apitoken);
    }
  }

  sendOtp(mobile_no: string, token: string): void {
    this.http.post(this.apiUrl, { mobile_no: mobile_no, token: token })
      .subscribe(
        (response: any) => {
          const res = response?.response ?? response;
          if (res?.status) {
            alert(res?.msg || 'Otp sent to WhatsApp');
          } else {
            alert(res?.msg || 'Unable to send OTP. Please try again later.');
          }
        },
        error => {
          console.log(error);
          alert('Unable to send OTP. Please try again later.');
        }
      );
  }
  
  // async handleOtpSubmission(mobile_no: string, otp: string, p0: () => void): Promise<void> {
  async handleOtpSubmission(mobile_no: string, otp: string): Promise<void> {
    this.validateOtp(mobile_no, otp, this.apitoken).subscribe(
      async (response: any) => {
        const res = response?.response;
        if (res?.status) {
          // console.log('OTP validation successful:', response);

          try {
            const tokenResponse: any = await this.fetchToken().toPromise();
            const tokenRes = tokenResponse?.response;
            if (tokenRes?.status) {
              const bearerToken = tokenRes.data?.bearerToken;
              // Persist the session only once we have everything we need,
              // so a token failure never leaves the user half logged-in.
              localStorage.setItem('microsite', mobile_no);
              localStorage.setItem('profileData', JSON.stringify(res.data));
              localStorage.setItem('bearerToken', bearerToken);
              this.router.navigate(['/index']);

            //  p0();
              // console.log('Bearer token fetched and stored:', bearerToken);
            } else {
              console.error('Error fetching vouchers.Please try again', tokenRes?.msg);
              alert(tokenRes?.msg || 'Failed to fetch voucher token. Please resend the OTP and try again.');
            }
          } catch (error) {
            console.error('Error fetching bearer token:', error);
            alert('Error fetching voucher token. Please resend the OTP and try again.');
          }
        } else {
          alert(res?.msg || 'OTP Verification failed. Please try again.');
        }
      },
      error => {
        console.error('Error validating OTP:', error);
        alert('OTP Verification failed. Please try again.');
      }
    );
  }

  validateOtp(mobile_no: string, otp: string, token: string) {
    return this.http.post(this.valUrl, { mobile_no: mobile_no, otp: otp, token: token });
  }

  // fetch the bearer token from the database
  fetchToken() {
    const fetchTokenData = { clientId: this.clientId };
    console.log(fetchTokenData);

    return this.http.post(this.fetchTokenUrl, fetchTokenData);
  }

  async updateBearerToken(): Promise<void> {
    const fetchTokenData = {
      token: this.apitoken,
      clientId: environment.clientId,
      username: environment.username,
      password: environment.password,
      clientSecret: environment.clientSecret,
    };

    try {
      const response = await this.http.post<any>(this.updateauthandtokenUrl, fetchTokenData, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        })
      }).toPromise();

      // console.log('Token response:', response);

      if (response && response.response && response.response.data && response.response.data.token) {
        localStorage.setItem('bearerToken', response.response.data.token);
        // console.log('Bearer token stored:', response.response.data.token);
    } else {
        console.error('No bearer token received:', response);
        throw new Error('No bearer token received');
    }
    } catch (error) {
      console.error('Error fetching token:', error);
      throw error; // Propagate the error
    }
  }



  //-----------------authorization_code and bearer_token--------------------------------

  // async fetchBearerToken(): Promise<void> {
  //   try {
  //     const authorizationCode = await this.generateAuthCode();
  //     const payloads = {
  //       token: this.apitoken,
  //       clientId: '8c05ff8998d27375752012c45c4d5ed8',
  //       clientSecret: 'df2b81aff933239a278db8582600fc7a',
  //       authorizationCode: authorizationCode
  //     };

  //     const response: any = await this.http.post(this.bearerTokenApi, payloads).toPromise();

  //     if (!response?.response?.data) {
  //       console.error('Response format is invalid:', response);
  //       throw new Error('Invalid response format');
  //     }

  //     const dataString = response.response.data;

  //     let dataObject;
  //     try {
  //       dataObject = JSON.parse(dataString);
  //     } catch (parseError) {
  //       console.error('Error parsing response data:', parseError);
  //       throw new Error('Error parsing response data');
  //     }

  //     const bearerToken = dataObject.token;

  //     if (!bearerToken) {
  //       console.error('Bearer token not found in response data:', dataObject);
  //       throw new Error('Bearer token not found');
  //     }

  //     localStorage.setItem('bearerToken', bearerToken);
  //     console.log('Bearer token fetched and stored:', bearerToken);
  //   } catch (error) {
  //     console.error('Error fetching bearer token:', error);
  //     this.handleTokenRejected();
  //     throw error;
  //   }
  // }

  async fetchBearerToken(): Promise<void> {
    try {
      const authorizationCode = await this.generateAuthCode();
      const payloads = {
        token: this.apitoken,
        clientId: '8c05ff8998d27375752012c45c4d5ed8',
        clientSecret: 'df2b81aff933239a278db8582600fc7a',
        authorizationCode: authorizationCode
      };

      const response: any = await this.http.post(this.bearerTokenApi, payloads).toPromise();

      console.log('API Response:', response);

      if (response.status !== 1 || !response.data) {
        console.error('Response format is invalid or an error occurred:', response);
        throw new Error('Invalid response format or error occurred');
      }

      const dataString = response.data;

      if (dataString.startsWith('<!DOCTYPE')) {
        console.error('Received HTML response instead of JSON:', dataString);
        throw new Error('Received HTML response instead of JSON');
      }

      let dataObject;
      try {
        dataObject = JSON.parse(dataString);
      } catch (parseError) {
        console.error('Error parsing response data:', parseError);
        throw new Error('Error parsing response data');
      }

      const bearerToken = dataObject.token;

      if (!bearerToken) {
        console.error('Bearer token not found in response data:', dataObject);
        throw new Error('Bearer token not found');
      }

      localStorage.setItem('bearerToken', bearerToken);
      console.log('Bearer token fetched and stored:', bearerToken);
    } catch (error) {
      console.error('Error fetching bearer token:', error);
      // this.handleTokenRejected();
      // throw error;
    }
  }


  async ensureBearerToken(): Promise<string> {
    let bearerToken = localStorage.getItem('bearerToken');

    if (!bearerToken) {
      await this.fetchBearerToken();
      bearerToken = localStorage.getItem('bearerToken');
    }

    if (!bearerToken) {
      throw new Error('Bearer token could not be fetched or found');
    }

    return bearerToken;
  }

  handleTokenRejected(): void {
    localStorage.removeItem('microsite');
    localStorage.removeItem('profileData');
    localStorage.removeItem('bearerToken');
    this.router.navigate(['/otp']);
  }

  async generateAuthCode(): Promise<string> {
    const payloads = {
      token: this.apitoken,
      clientId: '8c05ff8998d27375752012c45c4d5ed8',
      username: 'shounak.chakraborty@centuryply.com',
      password: 'U+055;LdqzJ#'
    };

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Accept: 'application/json'
    });

    try {
      const response: any = await this.http.post(this.authApi, payloads, { headers }).toPromise();
      const dataString = response.response.data;
      const dataObject = JSON.parse(dataString);
      const authorizationCode = dataObject.authorizationCode;
      return authorizationCode;
    } catch (error) {
      console.error('Error fetching authorization code:', error);
      throw error;
    }
  }


  //---------logout---------
  logout(): void {
    // Clear local storage
    localStorage.removeItem('microsite');
    localStorage.removeItem('profileData');
    localStorage.removeItem('bearerToken');

    // Redirect to OTP submission page
    this.router.navigate(['/otp']);
  }


}